import "@/App.css";
import "@/i18n";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Toaster } from "sonner";
import { CartProvider } from "@/context/CartContext";
import { AuthProvider } from "@/context/AuthContext";
import { CurrencyProvider } from "@/context/CurrencyContext";
import { CookieBanner } from "@/components/CookieBanner";
import { ScrollToTop } from "@/components/ScrollToTop";
import { ConciergeWidget } from "@/components/ConciergeWidget";
import { bootstrapTracking, trackPageView } from "@/lib/tracking";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import WhoWeAre from "@/pages/WhoWeAre";
import ProductPage from "@/pages/ProductPage";
import Shop from "@/pages/Shop";
import HowItWorks from "@/pages/HowItWorks";
import Professional from "@/pages/Professional";
import Support from "@/pages/Support";
import Faq from "@/pages/Faq";
import Contact from "@/pages/Contact";
import Quiz from "@/pages/Quiz";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import Legal from "@/pages/Legal";
import Arts from "@/pages/Arts";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Account from "@/pages/Account";
import OrderTrack from "@/pages/OrderTrack";
import Blog from "@/pages/Blog";
import BlogArticle from "@/pages/BlogArticle";

function AnalyticsBootstrap() {
  const location = useLocation();
  useEffect(() => { bootstrapTracking(); }, []);
  useEffect(() => { trackPageView(location.pathname + location.search); }, [location.pathname, location.search]);
  return null;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <AnalyticsBootstrap />
        <AuthProvider>
          <CurrencyProvider>
          <CartProvider>
            <Routes>
              <Route element={<Layout />}>
                <Route path="/" element={<Home />} />
                <Route path="/who-we-are" element={<WhoWeAre />} />
                <Route path="/preshhgo" element={<ProductPage />} />
                <Route path="/shop" element={<Shop />} />
                <Route path="/product/:slug" element={<ProductPage />} />
                <Route path="/how-it-works" element={<HowItWorks />} />
                <Route path="/professional" element={<Professional />} />
                <Route path="/support" element={<Support />} />
                <Route path="/faq" element={<Faq />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/blog" element={<Blog />} />
                <Route path="/blog/:slug" element={<BlogArticle />} />
                <Route path="/quiz" element={<Quiz />} />
                <Route path="/arts" element={<Arts />} />                <Route path="/payment/success" element={<PaymentSuccess />} />
                <Route path="/payment/cancel" element={<PaymentCancel />} />
                <Route path="/legal/:page" element={<Legal />} />
                <Route path="/login" element={<Login />} />
                <Route path="/register" element={<Register />} />
                <Route path="/account" element={<Account />} />
                <Route path="/track" element={<OrderTrack />} />
              </Route>
              <Route path="/admin" element={<AdminLogin />} />
              <Route path="/admin/dashboard" element={<AdminDashboard />} />
            </Routes>
            <ConciergeWidget />
            <CookieBanner />
            <Toaster theme="dark" position="top-right" richColors />
          </CartProvider>
          </CurrencyProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
